<script setup>
	import {Link}  from '@inertiajs/vue3';
	import {scrollTop} from "@/utility";
</script>

<template>
	<li class="list-item" :class="{
		'parent' : (item_data.children && item_data.children.length && level <= 1),
		'extended' : uicontrol.extended
	}" @click.self="uicontrol.extended = !uicontrol.extended">

		<!-- Internal route -->
		<Link v-if="item_data.route.slug !== null" :href="slug(item_data.route, null)" :alt="item_data.title" :onFinish="scrollTop">
			<span>{{item_data.title}}</span>
		</Link>

		<!-- External route -->
		<a :href="item_data.route.url" target="_blank" v-else>
			<span>{{item_data.title}}</span>
		</a>

		<ul :class="'level_' + level" v-if="item_data.children && item_data.children.length && level <= 1">
			<list_item :level="level + 1" v-for="item in item_data.children" :item_data="item"></list_item>
		</ul>
	</li>
</template>

<script>

export default {
	name: "list_item",
	props : [
		'item_data',
		'level'
	],
	data(){
		return {
			uicontrol : {
				extended : false
			}
		}
	},
	methods : {

		slug(route, parentRoute){

			return route.name ? this.route(route.name) : '/' + route.slug;

		}

	}
}
</script>

<style scoped>

</style>